import { api } from "../api";
import { backendErrors } from "@/forms/service/common";
import { SIGNUP_STEPS } from "@/forms/service/auth";
import { ValidateEmail } from "@/api/forms";

export const zthThankYou = (formData: any, prevResponse: any) => {
  api.forms.triggerEvents({
    events: ["App\\Events\\ZeroToHeroRegistrationTeachable"],
    fields: {
      formData,
      callResponse: prevResponse
    }
  });
};

export const mastersOfTradingThankyou = (formData: any, prevResponse: any) => {
  api.forms.triggerEvents({
    events: ["App\\Events\\MastersOfTrading"],
    fields: {
      formData,
      callResponse: prevResponse
    }
  });
};

export const zthFirstStep = async (data: ValidateEmail) => {
  const { data: validateDate } = await api.forms.validateEmail(data);

  if (validateDate.errors) {
    throw { errors: backendErrors(validateDate.errors) };
  }

  if (!validateDate.success) {
    return {
      next: SIGNUP_STEPS.SECOND_STEP,
      data: validateDate
    };
  }
  return {
    next: SIGNUP_STEPS.THANK_YOU_STEP,
    data: validateDate
  };
};
